import Vue from "vue";
import LoadingVue from "./Index.vue";
import PopPlugins from "@/utils/popPlugins";

const LoadingConstructor = Vue.extend(LoadingVue);

class Loading extends PopPlugins {
	constructor(name, vueConstructor, options) {
		super(name, vueConstructor, options);
		this.ShowNum = 0;
	}
	show() {
		this.ShowNum++;
		super.show();
	}
	hide() {
		this.ShowNum--;
		if (this.ShowNum == 0) {
			super.hide();
		}
	}
}

const instance = new Loading("Loading", LoadingConstructor);

export default {
	install(Vue) {
		Vue.prototype.$loading = instance;
	},
};
export { instance };
